/**
 * This component is currently unused but kept for future implementation.
 * Remove if no longer needed.
 */

"use client";
import { fetchShimmerPlaceholder, getColorKey } from "@areahub/ui";
import { Box, Center, Heading, SimpleGrid, Stack } from "@chakra-ui/react";
import { PageBlockGridItemFeatureIcon } from "lib/gcms";
import { PageBlockFeatureItemGrid } from "lib/gcms/gcms-typings";
import Image from "next/legacy/image";
import { SectionTemplate } from "../section-template";
import Feature from "./feature-icon";

const FeatureGrid = ({
  gridItems,
  title,
  children,
  image,
  bg,
  color,
  gridProperties,
}: PageBlockFeatureItemGrid) => {
  const colorKey = getColorKey("teal", "blue");

  return (
    <SectionTemplate {...{ bg, color }}>
      <Heading textAlign="center" size="2xl" fontWeight="extrabold">
        {title}
      </Heading>
      {children && (
        <Box as="div" fontSize="lg" mt="6" textAlign="center">
          {children}
        </Box>
      )}
      <Box mt={{ base: "10", md: "24" }} px={{ base: "2", md: "8" }}>
        <SimpleGrid {...gridProperties} spacing={{ base: "16", md: "8" }}>
          <Stack spacing="12" maxW="lg">
            {gridItems &&
              gridItems?.map(
                (item: PageBlockGridItemFeatureIcon, index: number) => (
                  <Feature
                    key={item?.id}
                    icon={item?.icon}
                    title={item?.title}
                    layout={item?.layout}
                    index={index}
                  >
                    {item.content}
                  </Feature>
                ),
              )}
          </Stack>
          {image && (
            <Center
              alignSelf="center"
              minH="26rem"
              display={{ base: "none", md: "block" }}
            >
              {/* <Image
                style={{ objectFit: "cover" }}
                height={image?.height as number}
                width={image?.width as number}
                loading="lazy"
                src={image?.url}
                alt={image?.handle}
                placeholder="blur"
                blurDataURL={fetchShimmerPlaceholder(
                  image.width as number,
                  image.height as number,
                  [colorKey[100], colorKey[400]],
                )}
              /> */}
            </Center>
          )}
        </SimpleGrid>
      </Box>
    </SectionTemplate>
  );
};

export default FeatureGrid;
